var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiCloseChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C8.58333 20 7.26667 19.7458 6.05 19.2375C4.83333 18.7292 3.775 18.025 2.875 17.125C1.975 16.225 1.27083 15.1667 0.7625 13.95C0.254167 12.7333 0 11.4167 0 10C0 8.6 0.254167 7.29167 0.7625 6.075C1.27083 4.85833 1.975 3.8 2.875 2.9C3.775 2 4.83333 1.29167 6.05 0.775C7.26667 0.258333 8.58333 0 10 0C11.25 0 12.4167 0.2 13.5 0.6C14.5833 1 15.5583 1.55 16.425 2.25L15.35 3.325C14.6167 2.74167 13.8 2.29167 12.9 1.975C12 1.65833 11.0333 1.5 10 1.5C7.58333 1.5 5.5625 2.3125 3.9375 3.9375C2.3125 5.5625 1.5 7.58333 1.5 10C1.5 12.4167 2.3125 14.4375 3.9375 16.0625C5.5625 17.6875 7.58333 18.5 10 18.5C12.4167 18.5 14.4375 17.6875 16.0625 16.0625C17.6875 14.4375 18.5 12.4167 18.5 10C18.5 9.5 18.4625 9.0125 18.3875 8.5375C18.3125 8.0625 18.2 7.6 18.05 7.15L19.2 6C19.4667 6.61667 19.6667 7.25833 19.8 7.925C19.9333 8.59167 20 9.28333 20 10C20 11.4167 19.7417 12.7333 19.225 13.95C18.7083 15.1667 18 16.225 17.1 17.125C16.2 18.025 15.1417 18.7292 13.925 19.2375C12.7083 19.7458 11.4 20 10 20ZM8.525 14.55L4.4 10.4L5.525 9.275L8.525 12.275L18.875 1.925L20.025 3.05L8.525 14.55Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiCloseChat);
export default __webpack_public_path__ + "static/media/multiCloseChat.12334eda.svg";
export { ForwardRef as ReactComponent };